import { createEventFactory } from '@cp/shared/tracking';
import { OAuthVariants } from '@common/model/client/oauth/oauthService';
import { ClientType } from '@common/model/client/clientType';
import { clientTypeToEventParam } from 'src/shared/tracking';
import { LoginStrategy, SelectedAuthOption } from '../model';

const authVariantToSingleValue = (variant: SelectedAuthOption): string => {
  switch (variant.strategy) {
    case LoginStrategy.Email:
      return 'Почта';
    case LoginStrategy.Phone:
      return 'Телефон';
    case LoginStrategy.OAuth:
      switch (variant.provider) {
        case OAuthVariants.Apple:
          return 'Apple';
        case OAuthVariants.Google:
          return 'Google';
        case OAuthVariants.Telegram:
          return 'Telegram';
        default:
          return String(variant.provider);
      }
    default:
      return variant.strategy;
  }
};

export const LoginButtonClickEvent = createEventFactory<void>({
  subject: 'auth',
  action: 'login',
  goalId: 'nazhatie_na_knopku_vojti_v_navigacii',
  goalName: 'Нажатие на кнопку "Войти" в навигации',
});

export const AuthVariantModalOpened = createEventFactory<void>({
  subject: 'auth',
  object: 'variants-popup',
  action: 'open',
  goalId: 'poyavlenie_popapa_avtorizacii',
  goalName: 'Появление попапа авторизации',
  nonInteraction: true,
});

export const AuthVariantSelected = createEventFactory<Record<string, string>, { variant: SelectedAuthOption; clientType?: ClientType }>(
  {
    subject: 'auth',
    object: 'variant',
    action: 'selected',
    goalId: 'Выбор способа авторизации',
    goalName: 'vybor_sposoba_avtorizacii',
  },
  ({ variant, clientType }) => ({ 'Вариант': authVariantToSingleValue(variant), ...clientTypeToEventParam(clientType) }),
);

export const AuthResult = createEventFactory<
  {
    'Вариант'?: string;
    'Статус': string;
    'Тип пользователя'?: string;
    'Статус пользователя': 'Новый' | 'Текущий';
  },
  { variant?: SelectedAuthOption | null; error?: Error; clientType?: ClientType; isRegistered?: boolean }
>(
  {
    subject: 'auth',
    action: 'result',
    goalId: 'Авторизация',
    goalName: 'avtorizacii',
    nonInteraction: true,
  },
  ({ variant, error, clientType, isRegistered }) => ({
    'Статус': error ? error.message : 'Успешно',
    'Статус пользователя': isRegistered ? 'Текущий' : 'Новый',
    ...(variant && { 'Вариант': authVariantToSingleValue(variant) }),
    ...clientTypeToEventParam(clientType),
  }),
);

export const LoginModalOpened = createEventFactory<void>({
  subject: 'auth',
  object: 'popup',
  action: 'open',
  result: 'success',
  goalId: 'poyavlenie_popapa_s_nomerom_telefona',
  goalName: 'Появление попапа с номером телефона',
  nonInteraction: true,
});

export const AuthByPhoneFormSubmit = createEventFactory<void>({
  subject: 'auth',
  object: 'phone',
  action: 'submit',
  goalId: 'nazhatie_na_knopku_poluchit_kod_v_popape_avtorizacii',
  goalName: 'Нажатие на кнопку "Получить код" в попапе авторизации',
});

export const AuthSMSCodeSubmit = createEventFactory<{ status: string }>({
  subject: 'auth',
  object: 'otp',
  action: 'submit',
  goalId: 'vvod_koda_pri_avtorizacii',
  goalName: 'Ввод кода при авторизации',
});
